import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContable', salida.value)
      setFieldValue('cuentaContableInfo', salida.label)
      setFieldValue('flagCentroCosto', salida.flagCentroCosto)

      if (salida.flagCentroCosto) {
        KeyEventUtil.leaveOnKeyEvent('select-centroCostoNivel1', {
          timeOut: 300
        })
      } else {
        KeyEventUtil.leaveOnKeyEvent('button-nuevoSinDoc-procesar')
      }
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContable', '')
    setFieldValue('cuentaContableInfo', '')
    setFieldValue('_idCentroCostoNivel1', '')
    setFieldValue('_idCentroCostoNivel2', '')
    setFieldValue('centroCostoNivel2Info', '')
    setFieldValue('flagCentroCosto', false)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select2-cuentaContable')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CUENTA CONTABLE' htmlFor='select2-cuentaContable' md={3} alignRightAt='md' />
      <Col md={9}>
        {iValue ? (
          <ClearInputGroup id='cuentaContable' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select2-cuentaContable' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
